import {PdfViewerProps} from 'common/pdf-viewer/pdf-viewer.types';

export const PdfViewerPresets: Partial<PdfViewerProps> = {
    elements: []
}